// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';

const fragments = {
  TOGGLE_MENU_STICKY: '[data-fragment="WebLayout.toggleMenuSticky"]',
  WEB_OVERLAY_STICKY: '[data-fragment="WebLayout.webOverlaySticky"]',
  HEADER_MENU: '[data-fragment="WebLayout.headerMenu"]',
  BREADCRUMB: '[data-fragment="WebLayout.breadcrumb"]',
  SUBMENU_POPUP: '[data-fragment="WebLayout.submenuPopup"]',
  TOGGLE_SUBMENU_DESKTOP: '[data-fragment="WebLayout.toggleSubmenuDesktop"]'
};

export default class WebLayout extends WebComponent {

  constructor(props) {
    super(props);
    this.scrollFn = this.scrollFn.bind(this);
    this.handleTouchOnSubmenu = this.handleTouchOnSubmenu.bind(this);
    this.handleTouchOnOverlay = this.handleTouchOnOverlay.bind(this);
    this.handleMouseClickOnSubmenu = this.handleMouseClickOnSubmenu.bind(this);
    this.handleMouseLeaveOnSubmenu = this.handleMouseLeaveOnSubmenu.bind(this);
    this.appendPreloader = this.appendPreloader.bind(this);
    this.productListingAnchor = this.productListingAnchor.bind(this);
    this.stickyMenu = this.stickyMenu.bind(this);
    this.stickyMenuReset = this.stickyMenuReset.bind(this);
    this.getScrollBarWidth = this.getScrollBarWidth.bind(this);
    this.isDescendant = this.isDescendant.bind(this);
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
    this.timeout = null;
  }

  didMount() {
    this.appendPreloader();
    this.productListingAnchor();
    //check for touch devices
    function is_touch_enabled() {
      return ( 'ontouchstart' in window ) ||
        ( navigator.maxTouchPoints > 0 ) ||
        ( navigator.msMaxTouchPoints > 0 );
    }
    const self = this;
    this.body = document.querySelector('body');
    this.fakeScrollbar = document.querySelector('.fake-scrollbar');
    this.header = this.element.querySelector('.header');
    this.toggleMenu = this.element.querySelector('.header__menu-toggle');
    this.eshopMenu = this.element.querySelector('.header__eshop-menu');
    this.submenu = this.element.querySelectorAll('.submenu');
    this.submenuPopup = this.element.querySelector(fragments.SUBMENU_POPUP);
    this.submenuToggle = this.element.querySelectorAll('.submenu__toggle');
    this.webOverlay = document.querySelector('.web-overlay');
    this.toggleMenuSticky = this.element.querySelector(fragments.TOGGLE_MENU_STICKY);
    this.webOverlaySticky = this.element.querySelector(fragments.WEB_OVERLAY_STICKY);
    this.headerMenu = this.element.querySelector(fragments.HEADER_MENU);
    this.breadcrumb = this.element.querySelector('.breadcrumb-container');
    this.toggleSubmenuDesktop = this.element.querySelector(fragments.TOGGLE_SUBMENU_DESKTOP);
    this.clickCount = 0;

    window.removeEventListener('scroll', this.scrollFn);
    window.addEventListener('scroll', this.scrollFn);
    this.lastScrollTop = 0;

    if(this.submenu) {

      if(is_touch_enabled()){
        this.body.classList.add('touch-device');

        this.submenuToggle.forEach( (item) => {
          // touch start on touch devices
          item.addEventListener('touchstart', this.handleTouchOnSubmenu);
          // close upon touch on overlay
          this.webOverlay.addEventListener('touchstart', this.handleTouchOnOverlay);
        });

      }else {
        this.submenu.forEach( (item) => {
          const link = item.querySelector('.submenu__toggle');
          link.addEventListener('click', this.handleMouseClickOnSubmenu);
          item.addEventListener('mouseleave', this.handleMouseLeaveOnSubmenu);
        });
      }
    }

    if(this.toggleMenu) {
      this.toggleMenu.addEventListener('click', (e) => {
        self.lastScrollTop = 9999;
        this.body.classList.remove('menu--on');
      });
    }

    if(this.toggleMenuSticky) {
      self.stickyMenu();
    }

    if(this.toggleSubmenuDesktop) {
      this.toggleSubmenuDesktop.addEventListener('click',self.toggleSubmenu);
    }

    // handling borders in lvl-2 subcategory listing
    const lvl2Listing = document.querySelector('.subcategory-list--lvl2');
    if(lvl2Listing) {
      const lvl2ListingItems = lvl2Listing.querySelectorAll('.subcategory-list__item');

      if(lvl2ListingItems && lvl2ListingItems.length > 4) {
        lvl2Listing.classList.add('subcategory-list--lvl2-2rd') // 2 rows desktop
      }else if(lvl2ListingItems && lvl2ListingItems.length > 8) {
        lvl2Listing.classList.add('subcategory-list--lvl2-3rd') // 3 rows desktop
      }
    }
  }

  handleTouchOnSubmenu (e) {
    // prevent default behaviour of link on menu touch
    if (e.cancelable) {
      //e.preventDefault();
      if(this.clickCount === 0){e.preventDefault()}
    }
    this.clickCount = 1;
    let touchedItem = e.target;
    // remove active state on all at first
    this.submenu.forEach( (item) => {
      item.classList.remove('opened');
      // item.classList.remove('opened--sticky');
    });
    this.body.classList.remove('menu--on');
    this.header.classList.remove('menu--on');
    // add where needed
    if(!touchedItem.parentNode.classList.contains('opened')) {
        touchedItem.closest('.submenu').classList.toggle('opened');
        touchedItem.closest('.submenu').classList.toggle('opened--sticky');
        this.body.classList.toggle('menu--on');
        this.header.classList.toggle('menu--on');
    }
  }

  handleTouchOnOverlay (e) {
    // prevent default behaviour of link on menu touch
    if (e.cancelable) {
      e.preventDefault();
    }
    this.submenu.forEach( (item) => {
      item.classList.remove('opened');
    });
    this.body.classList.remove('menu--on');
    this.header.classList.remove('menu--on');
    this.clickCount = 0;
  }

  handleMouseClickOnSubmenu (e) {
    if (this.body.classList.contains('sticky-menu--on')) {
      this.clickCount === 1 ? e.target.click : e.preventDefault()
      this.clickCount = 1;
      e.target.closest('.submenu').classList.add('opened--sticky');
    } else {
      this.clickCount === 1 ? e.target.click : e.preventDefault()
      this.clickCount = 1;
      e.target.closest('.submenu').classList.add('opened');
      this.body.classList.add('menu--on');
      this.header.classList.add('menu--on');
/*      const scrollbarWidth = this.getScrollBarWidth();
      this.body.style.paddingRight = scrollbarWidth + 'px';
      this.fakeScrollbar.style.width = scrollbarWidth + 'px';*/
    }
  }

  handleMouseLeaveOnSubmenu (e) {
    e.target.closest('.submenu').classList.remove('opened');
    // !!! Remove "menu--on" from body at this point because client changed menu to 1 item only, therefore we dont need to keep this class on budy on leaving msubmenu.
    if (this.body.classList.contains('menu--on')) {
      this.body.classList.remove('menu--on');
      this.header.classList.remove('menu--on');
/*      this.body.style.paddingRight = 'inherit';
      this.fakeScrollbar.style.width = 'inherit';*/
      this.clickCount = 0;
    }
  }

  willUnmount() {
    window.removeEventListener('scroll', this.scrollFn);
  }

  scrollFn(e) {
    if (this.element) {
      const self = this;

      if (this.header) {

        let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

        this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        if ((!this.body.classList.contains('menu--on')) && ((window.innerWidth >= 992 && self.lastScrollTop > 274) || (window.innerWidth < 992 && self.lastScrollTop != 0))) {
          self.header.classList.add('header--sticky');
          self.body.classList.add('sticky-header--on');
          if (window.innerWidth >= 992) {
            self.submenuPopup.classList.remove('submenu__popup');
            self.submenuPopup.classList.add('submenu__popup--sticky');
          }
        } else {
          if (self.header.classList.contains('header--sticky')) {
            self.header.classList.add('header--sticky-removed');
            self.submenuPopup.classList.add('submenu__popup');
            self.submenuPopup.classList.remove('submenu__popup--sticky');
            window.setTimeout(function(){
              self.header.classList.remove('header--sticky');
              self.body.classList.remove('sticky-header--on');
              self.header.classList.remove('header--sticky-removed');
            },300);
          }
        }
      }
    }
  }

  appendPreloader() {
    if ($('#productDetail').length != 0) {
      let htmlLoader = $("#loader");
      if (htmlLoader.length == 0) {
        htmlLoader = $('<div id="loader" style="position: absolute; overflow: hidden; z-index: 1000000; position: fixed; left: 50%; top: 50%;"><img src="data:image/gif;base64,R0lGODlhEAAQAKIGANjY2O7u7mRkZAQEBE5OTr6+vv///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAGACwAAAAAEAAQAAADKWi63P4wykkVuMBijUPIBuCB4leSozWe6tdeaRifrOza2MWRW+X/wEYCACH5BAkKAAYALAAAAwAEAAsAAAMLOKpE7KO9GaGsdCUAIfkECQoABgAsAAAAABAAEAAAAzFoutz+MMZBhxNYqEGIbUJRaAbnXSJpfkw4bh27uGqMvqUNpvC546tLpieDVIqSpDIBACH5BAkKAAYALAAAAAAQABAAAAM9aLrc/jDKNupwIgs1CBlACChCUWxG9wFBMBrlyXlg+8aoWrukmdMsHsw3W9l6shRQhPx9MJriZWKZTq6PBAAh+QQFCgAGACwAAAAAEAAQAAADMmi63P4wyimFFSADpbcRRYEFgQeQHiieJYcq6tgabBrK5vvdtTvHHY4GdqNcBJSkMpIAACH5BAkKAAYALAYAAwAKAAsAAAMYODrWPoQw16CkNU5q99OY0YUjVnKguYQJACH5BAkKAAYALAAAAAAQABAAAAM8aLrc/jCuQYdUgxBrhBdOtilCUYAGoAIiV54KEASs5pqoTLckHs+1UceXAvKGsOLO1kuugq5PqHKpWiEJACH5BAkKAAYALAAAAAAQABAAAAMzaLrc/jDKKKqYRpRyDfiAAgIaJwZB6KHk1gHsmZZvvM6urMK4ee8smgg0/Fg6mKRyyUgAACH5BAUKAAYALAAAAAAQABAAAAMpaLrc/jDKSRW4wGKNQ8gG4IHiV5KjNZ7q115pGJ+s7NrYxZFb5f/ARgIAIfkEBSMABgAsAAAAAAEAAQAAAwJoCQA7"/></div>');
        $(document.body).append(htmlLoader);
      }
      $("#loader").show();
      window.__ajaxLoaderHidden = false;

      window.onload = function() {
        $("#loader").hide();
        window.__ajaxLoaderHidden = true;
      };
    }
  }

  productListingAnchor() {
    if (location.hash != '' && location.hash.includes('_tileItem_')) {
      $('html, body').scrollTop($(location.hash).offset().top);
      $(document).ready(function() {
        $('html, body').scrollTop($(location.hash).offset().top);
      });
    }
  }

  stickyMenu() {
    const self = this;
    if (this.breadcrumb) {
      const cloneBreadcrumb = this.breadcrumb.cloneNode(true);
      this.headerMenu.prepend(cloneBreadcrumb);
    }
    this.toggleMenuSticky.addEventListener('click', function(e){
      e.stopPropagation();
      self.webOverlaySticky.classList.toggle('active');
      self.toggleMenuSticky.classList.toggle('active');
/*      if (self.body.classList.contains('sticky-menu--on')) {
        self.body.style.paddingRight = 'inherit';
      } else {
        self.body.style.paddingRight = self.getScrollBarWidth() + 'px';
      }*/
      self.body.classList.toggle('sticky-menu--on');
      self.headerMenu.classList.toggle('active');
      if (!self.toggleMenuSticky.classList.contains('active')) {
        self.body.classList.remove('menu--on');
        self.header.classList.remove('menu--on');
        self.submenu.forEach( (item) => {
          item.classList.remove('opened');
        });
      }
    });

    window.addEventListener('click', function(e) {
      if (!self.isDescendant(self.headerMenu, e.target) && e.target != self.headerMenu) {
        self.stickyMenuReset();
      }
    })

    window.addEventListener("resize", function() {
      if (self.lastScrollTop == 0) {
        self.stickyMenuReset();
      }
      if (window.innerWidth < 992) {
        self.submenuPopup.classList.add('submenu__popup');
        self.submenuPopup.classList.remove('submenu__popup--sticky');
      }
      self.clickCount = 0;
    });
  }

  toggleSubmenu() {
    const self = this;
    this.submenu.forEach( (item) => {
      if (self.body.classList.contains('sticky-menu--on')) {
        item.classList.toggle('opened--sticky');
        if (item.classList.contains('opened--sticky')) {
          self.clickCount = 1;
        } else {
          self.clickCount = 0;
        }
      } else {
        item.classList.toggle('opened');
        self.body.classList.toggle('menu--on');
        self.header.classList.toggle('menu--on');
        if (self.body.classList.contains('menu--on')) {
          const scrollbarWidth = this.getScrollBarWidth();
/*          this.body.style.paddingRight = scrollbarWidth + 'px';
          this.fakeScrollbar.style.width = scrollbarWidth + 'px';*/
          self.clickCount = 1;
        } else {
/*          this.body.style.paddingRight = 'inherit';
          this.fakeScrollbar.style.width = 'inherit';*/
          self.clickCount = 0;
        }
      }
    });
  }

  stickyMenuReset() {
    this.webOverlaySticky.classList.remove('active');
    this.toggleMenuSticky.classList.remove('active');
    this.body.classList.remove('sticky-menu--on');
    this.body.style.paddingRight = 'inherit';
    this.fakeScrollbar.style.width = 'inherit';
    this.headerMenu.classList.remove('active');
    this.body.classList.remove('menu--on');
    this.header.classList.remove('menu--on');
    this.submenu.forEach( (item) => {
      item.classList.remove('opened');
    });
  }

  getScrollBarWidth() {
    const inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    const outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild (inner);

    document.body.appendChild (outer);
    let w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild (outer);

    return (w1 - w2);
  }

  isDescendant(parent, child) {
    let node = child.parentNode;
    while (node != null) {
      if (node == parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js